export default __webpack_public_path__ + "static/media/icon-27.8bf5f818.png";